import React from 'react';
import { utils } from 'kb-shared';

interface KindbodyCancellationPolicyProps {
  emailBody: string;
}

export const KindbodyCancellationPolicy = ({ emailBody }: KindbodyCancellationPolicyProps) => (
  <p>
    Appointments canceled more than 24 hours prior will not be charged.&nbsp; For appointments
    canceled with less than 24 hours notice, we&#8217;ll charge you a fee of $100. To reschedule or
    cancel with less than 24 hours notice, or if you have any questions, email us at{' '}
    <a
      className="link"
      href={`mailto:${utils.KBContacts.navigatorEmail}?subject=Appointment Cancellation${emailBody}`}
    >
      {utils.KBContacts.navigatorEmail}
    </a>{' '}
    or call us at{' '}
    <a className="link" href={`tel:${utils.KBContacts.navigatorNumber}`}>
      {utils.KBContacts.navigatorNumber}
    </a>
    .
  </p>
);
